<template>
  <div>
    <!-- Mobile drawer overlay -->
    <Transition name="fade">
      <div v-if="drawer" class="fixed inset-0 bg-black/60 z-40 lg:hidden" @click="drawer = false"></div>
    </Transition>

    <!-- Mobile drawer -->
    <Transition name="slide">
      <div v-if="drawer" class="fixed top-0 right-0 w-72 h-full bg-dark border-l border-white/10 z-50 lg:hidden">
        <div class="flex items-center justify-between px-6 h-16 border-b border-white/5">
          <span class="text-white font-bold text-lg">Team<span class="text-neon">Collab</span></span>
          <button @click="drawer = false" class="text-gray-400 hover:text-white" aria-label="Fechar menu">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav class="p-6 space-y-2">
          <a v-for="([icon, text, link], i) in items" :key="i" @click="goToElement(link)"
            class="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-300 hover:bg-white/5 hover:text-white transition-all cursor-pointer">
            <span class="text-sm font-medium">{{ text }}</span>
          </a>
        </nav>
      </div>
    </Transition>

    <!-- Navbar -->
    <nav class="fixed top-0 w-full z-40 transition-all duration-300"
      :class="scrolled ? 'bg-dark/70 backdrop-blur-2xl' : 'bg-transparent'">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <a href="#" class="text-white font-bold text-xl tracking-tight">
          Team<span class="text-neon">Collab</span>
        </a>

        <!-- Desktop menu -->
        <div class="hidden lg:flex items-center gap-8">
          <a href="#hero" @click.prevent="goToElement('#hero')"
            class="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer">Início</a>
          <a href="#servicos" @click.prevent="goToElement('#servicos')"
            class="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer">Serviços</a>
          <a href="#ebiz" @click.prevent="goToElement('#ebiz')"
            class="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer">Produtos</a>
          <a href="#sobre" @click.prevent="goToElement('#sobre')"
            class="text-sm text-gray-500 hover:text-white transition-colors cursor-pointer">Sobre</a>
          <a href="#contact" @click.prevent="goToElement('#contact')"
            class="magnetic-btn btn btn-sm rounded-lg bg-brand text-white border-0 px-5 hover:bg-brand/90">
            <span>Contato</span>
          </a>
        </div>

        <!-- Mobile hamburger -->
        <button @click="drawer = !drawer" class="lg:hidden text-gray-400 hover:text-white" aria-label="Abrir menu">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      <div class="hr-glow"></div>
    </nav>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const drawer = ref(null)
const isXs = ref(false)
const scrolled = ref(false)

const items = [
  ["mdi-home-outline", "Início", "#hero"],
  ["mdi-information-outline", "Serviços", "#servicos"],
  ["mdi-package-variant", "Produtos", "#ebiz"],
  ["mdi-information-outline", "Sobre", "#sobre"],
  ["mdi-email-outline", "Contato", "#contact"],
]

function goToElement(id) {
  drawer.value = false
  if (route.path !== '/') {
    router.push('/' + id)
    return
  }
  const el = document.querySelector(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

function onResize() {
  isXs.value = window.innerWidth < 850
}

function onScroll() {
  scrolled.value = window.scrollY > 50
}

watch(isXs, (value) => {
  if (!value && drawer.value) {
    drawer.value = false
  }
})

onMounted(() => {
  onResize()
  onScroll()
  window.addEventListener('resize', onResize, { passive: true })
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('resize', onResize)
  window.removeEventListener('scroll', onScroll)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
